import React from 'react';
import {Button, Modal} from 'react-bootstrap';
import {Box} from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome';
import WorkdocStore from 'stores/WorkdocStore';
import ICheck from 'component/element/ICheck';
import Form from "react-jsonschema-form";
var NotificationSystem = require('react-notification-system');

const schema = {
    title: "",
    type: "object",
    required: [],
    properties: {
        show_print_billing: {type: "boolean", title: "แสดงใบวางบิลในหน้างานซ่อม", default: false},
        show_checkcar: {type: "boolean", title: "แสดงตรวจเช็ครถในใบงานซ่อม", default: false},
        show_receipt_menu: {type: "boolean", title: "แสดงเมนูใบเสร็จรับเงิน", default: false},
        contact_date_issue: {type: "boolean", title: "ใช้วันที่ติดต่อแสดงบนตาราง", default: false},
        show_notification: {type: "boolean", title: "แสดงแจ้งเตือน", default: false},
        chassis_no_primary:{type: "boolean", title: "แสดงเลขตัวถังเป็นคีย์หลัก", default: false},
        work_mechanic_commission: {type: "string", title: "% ค่าคอมให้ช่าง", default: "0.3"}
    }    
}
const uiSchema = {
    show_print_billing: {'ui:field': ICheck},
    show_checkcar: {'ui:field': ICheck},
    show_receipt_menu: {'ui:field': ICheck},
    contact_date_issue: {'ui:field': ICheck},
    show_notification: {'ui:field': ICheck},
    chassis_no_primary: {'ui:field': ICheck}
}
const _formData = {
    
}

class ConfigWorkModal extends React.Component {

  constructor(...args) {
    super(...args)
    this.state = {
        loading:false,
        formData:_formData
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData()
  }

  loadData() {
    this.setState({loading:true})
    WorkdocStore.loadConfigWork((result)=>{
        this.setState({formData:result.data,loading:false})
    })
  }

  onChange(e) {
    this.setState({formData:e.formData})
  }

  onSaveClick() {
      let {formData} = this.state
      this.setState({loading:true})
      WorkdocStore.saveConfigWork(formData,(result)=>{
        this.setState({loading:false})
        if (result.status==='OK') {
            this._notificationSystem.addNotification({
                title: 'แจ้งเตือน',
                message: 'บันทึกรายการสำเร็จ',
                level: 'info',
                position: 'tc'
            });
        }
    },()=>{
        this.setState({loading:false})
        this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'บันทึกรายการไม่สำเร็จ',
            level: 'error',
            position: 'tc'
        });
    })
  }

  renderForm() {
      let {formData,loading} = this.state
      return(
        <Box loading={loading}>  
            <Box.Body>
                <Form 
                    schema={schema}
                    uiSchema={uiSchema}
                    formData={formData}
                    onChange={this.onChange.bind(this)}
                >
                    <br/>
                </Form>
                <div style={{textAlign:'right'}}>
                    <Button className="btn-primary" onClick={this.onSaveClick.bind(this)}>
                        <FontAwesome name='save' />&nbsp;บันทึก
                    </Button>
                </div>   
                <NotificationSystem ref="notificationSystem" /> 
            </Box.Body>            
        </Box>    
      )
  }

  render() {
    let {show,mode} = this.props
    let {formData} = this.state
    if (mode!=='modal') {
        return this.renderForm()
    }
    return (
        <div>
            <Modal show={show} onHide={this.props.onHide}>
                <Modal.Header closeButton>
                <Modal.Title>
                    ตั้งค่า
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Form 
                    schema={schema}
                    uiSchema={uiSchema}
                    formData={formData}
                    onChange={this.onChange.bind(this)}
                >
                <br/>
                </Form>
                </Modal.Body>
                <Modal.Footer>
                <Button className="btn-primary" onClick={this.onSaveClick.bind(this)}>
                    <FontAwesome name='save' />&nbsp;บันทึก
                </Button>
                <Button className="btn-default" onClick={this.props.onHide}>
                    <FontAwesome name='close' />&nbsp;ปิด
                </Button>            
                </Modal.Footer>  
            </Modal>
            <NotificationSystem ref="notificationSystem" />
        </div>    
    )
  }
}

ConfigWorkModal.defaultProps = {
    mode: 'modal'
}

export default ConfigWorkModal;



// WEBPACK FOOTER //
// ./src/component/element/ConfigWorkModal.js